import locale_de_de from './locale_de_de';
import locale_en_us from './locale_en_us';
import locale_ar_ly from './locale_ar_ly';

let locales = {
    de_de: locale_de_de,
    en_us: locale_en_us,
    ar_ly: locale_ar_ly
};

export default locales;



// WEBPACK FOOTER //
// ./src/i18n/locales.js